export const GET_ALL_LANGUAGES = "GET_ALL_LANGUAGES";
export const CREATE_LANGUAGE = "CREATE_LANGUAGE";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const DELETE_LANGUAGE = "DELETE_LANGUAGE";
export const TOGGLE_LANGUAGE = "TOGGLE_LANGUAGE";
export const UPLOAD_TRANSLATIONS = "UPLOAD_TRANSLATIONS";
export const GET_LANGUAGE_TRANSLATIONS = "GET_LANGUAGE_TRANSLATIONS";
export const UPDATE_LANGUAGE_TRANSLATIONS = "UPDATE_LANGUAGE_TRANSLATIONS";
export const GET_LANGUAGE_OPTIONS = "GET_LANGUAGE_OPTIONS";
export const LOADER_OPEN = "LOADER_OPEN";
export const CLOSE_LOADER = "CLOSE_LOADER";
